import { ProgramTypes } from "../types/programTypes";
import type { ProgramMetricsRequest, ProgramDetailRequest } from "../types/programTypes";
import { config } from "../../config/config";

export const getProgramOnboardRequest = () => ({
  type: ProgramTypes.GET_PROGRAM_ONBOARD_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/program/onboard`,
        method: "GET",
      },
      commit: { type: ProgramTypes.GET_PROGRAM_ONBOARD_SUCCESS },
      rollback: { type: ProgramTypes.GET_PROGRAM_ONBOARD_FAILURE },
    },
  },
});

export const getProgramMetricsRequest = (payload: ProgramMetricsRequest) => ({
  type: ProgramTypes.GET_PROGRAM_METRICS_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/program/metrics`,
        method: "POST",
        json: payload,
      },
      commit: { type: ProgramTypes.GET_PROGRAM_METRICS_SUCCESS },
      rollback: { type: ProgramTypes.GET_PROGRAM_METRICS_FAILURE },
    },
  },
});

export const getProgramDetailRequest = (payload: ProgramDetailRequest) => ({
  type: ProgramTypes.GET_PROGRAM_DETAIL_REQUEST,
  meta: { cardType: payload.card_type },
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/program/detail`,
        method: "POST",
        json: payload,
      },
      commit: { type: ProgramTypes.GET_PROGRAM_DETAIL_SUCCESS, meta: { cardType: payload.card_type } },
      rollback: { type: ProgramTypes.GET_PROGRAM_DETAIL_FAILURE, meta: { cardType: payload.card_type } },
    },
  },
});
